export default __webpack_public_path__ + "static/media/mce-hce-icon.f3130124.svg";